import { AgResourceLanguage } from '../types';
import { banners as EnUsBanner } from '../en-us/banners';

export const banners: AgResourceLanguage['banners'] = {
  ...EnUsBanner,
  gift: {
    title: 'Envoyez un cadeau à vos amis et à votre famille',
    description:
      'Maintenant, vos proches peuvent essayer AG1 avec le cadeau de la Nutrition Fondamentale quotidienne.',
    iconAccessibleName: 'Cadeau',
    imageAccessibleName: 'Cadeau',
    buttonCloseLabel: 'Fermer',
    buttonShopLabel: 'Acheter des cadeaux'
  },
  paymentMethod: {
    title: 'Méthode de paiement manquante',
    description:
      'Ajoutez une méthode de paiement à votre abonnement pour continuer à recevoir des commandes d’abonnement.',
    addCtaBtnLabel: 'Ajouter maintenant',
    updateCtaBtnLabel: 'Mettre à jour maintenant'
  },
  stockBanner:
    'Les produits de votre prochaine expédition sont actuellement en rupture de stock et ne seront pas expédiés. Les articles en rupture de stock sont exclus du total de votre commande.',
  upcomingOrderBanner: {
    preparing: 'En préparation',
    shipped: 'Expédiée',
    delivered: 'Livrée',
    preparingDescription: 'Nous préparons votre commande.',
    shippedDescription: 'Votre commande en cours est en route.',
    deliveredDescription: 'Hourra! Vous avez reçu AG1.',
    orderDetailsLink: 'Voir les détails de la commande',
    trackingLink: 'Voir le suivi'
  },
  cookies: {
    text: 'Nous utilisons des cookies tiers et des technologies de suivi qui collectent des informations sur votre utilisation du site. Ces tiers peuvent utiliser vos informations à leurs propres fins, comme décrit dans notre ',
    link: 'Politique de confidentialité.'
  },
  promotionalBanner: {
    promotionMessage: 'Valeur incroyable',
    title: 'Plus de bonnes choses',
    descriptionPart1: 'Modifiez votre abonnement à 2 sacs et obtenez-les chacun pour 74,50 €',
    descriptionPart2:
      ' — parfait pour les couples, les familles et les membres très actifs qui souhaitent une deuxième cuillère d’AG1 chaque jour.',
    disclaimerFull:
      'Il est toujours préférable de consulter votre prestataire de soins pour déterminer quel mélange nutritionnel vous convient le mieux.',
    disclaimerShort:
      'Consultez votre prestataire de soins pour déterminer le meilleur niveau de nutrition pour vous.',
    buttonText: 'Ajouter un sac'
  },
  offerSoldOut: 'Cette offre est épuisée',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} est épuisé',
    soldOut_other: '{{soldOutProducts}} sont épuisés'
  }
};
